import React from "react"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../consts/appRoutes.consts"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"

const TeamMembersHeader = () => {
  const navigate = useNavigate()

  return (
    <ContentLayoutHeader
      title="Integrantes"
      buttonProps={{
        label: "Crear Integrante",
        icon: "pi pi-plus",
        className: "h-fit",
        onClick: () => {
          navigate(AppRoutes.integrantes.crear)
        },
      }}
    />
  )
}

export default TeamMembersHeader
